import { all } from 'redux-saga/effects';
import mainSaga from './mainSaga';
import WebFont from 'webfontloader';

export default function* rootSaga() {
  // REMOVED FOCUS FROM INPUT NUMBER TO PREVENT VALUE CHANGES
  if (document) {
    WebFont.load({
      google: {
        families: ['Inter', 'Futura PT'],
      },
    });
    document.addEventListener('wheel', function (event) {
      if ((document.activeElement as HTMLInputElement)?.type === 'number') {
        (document.activeElement as HTMLElement)?.blur();
      }
    });
  }

  yield all([mainSaga()]);
}
